import { VehicleAvailabilityModel } from './vehicle-availability.model';
import { VehicleModel } from './vehicle.model';
import { InstructorModel } from './instructor.model';
import { StudentEnrollmentModel } from './student-enrollment.model';
import { ClassPracticalsModel } from './class-practicals.model';
export class SchedulePracticalsModel {

  classPracticals?: ClassPracticalsModel[];
  classType?: string;
  createdByUsername?: string;
  createdDate?: any;
  enabled?: boolean;
  endDateTime?: any;
  id?: number;
  idInstructor?: number;
  idOrganization?: number;
  idStudentEnrollment?: number;
  idVehicle?: number;
  idVehicleAvailability?: number;
  instructor?: InstructorModel;
  startDateTime?: any;
  status?: string;
  studentEnrollment?: StudentEnrollmentModel;
  updatedByUsername?: string;
  updatedDate?: any;
  vehicle?: VehicleModel;
  vehicleAvailability?: VehicleAvailabilityModel;

  constructor(options: SchedulePracticalsModel = {}) {
    this.classPracticals = options.classPracticals || [];
    this.classType = options.classType || null;
    this.createdByUsername = options.createdByUsername || null;
    this.createdDate = options.createdDate || null;
    this.enabled = options.enabled || null;
    this.endDateTime = options.endDateTime || null;
    this.id = options.id || null;
    this.idInstructor = options.idInstructor || null;
    this.idOrganization = options.idOrganization || null;
    this.idStudentEnrollment = options.idStudentEnrollment || null;
    this.idVehicle = options.idVehicle || null;
    this.idVehicleAvailability = options.idVehicleAvailability || null;
    this.instructor = options.instructor || null;
    this.startDateTime = options.startDateTime || null;
    this.status = options.status || null;
    this.studentEnrollment = options.studentEnrollment || null;
    this.updatedByUsername = options.updatedByUsername || null;
    this.updatedDate = options.updatedDate || null;
    this.vehicle = options.vehicle || null;
    this.vehicleAvailability = options.vehicleAvailability || null;
  }
}
